export const DEFAULT_SIGNATURE_BYTE_COUNT = 8;
export const WEBM_EBML_SIGNATURE = '1a 45 df a3';

export type WebmBlobValidationStatus = 'valid' | 'suspicious';

export type WebmBlobAssessment = {
  signature: string | null;
  validationStatus: WebmBlobValidationStatus;
};

function formatHex(bytes: Uint8Array) {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(' ');
}

export async function getBlobSignature(
  blob: Blob | null | undefined,
  byteCount: number = DEFAULT_SIGNATURE_BYTE_COUNT,
): Promise<string | null> {
  if (blob == null || blob.size === 0) {
    return null;
  }

  try {
    const arrayBuffer = await blob.slice(0, byteCount).arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);
    return bytes.length > 0 ? formatHex(bytes) : null;
  } catch {
    return null;
  }
}

export async function assessWebmBlob(
  blob: Blob | null | undefined,
): Promise<WebmBlobAssessment> {
  const signature = await getBlobSignature(blob, 4);

  return {
    signature,
    validationStatus: signature === WEBM_EBML_SIGNATURE ? 'valid' : 'suspicious',
  };
}
